'use strict';

/* Use this file to generate generic modals, just pass in the rendered HTML */

/**
 * Generates the modal based on an ajax response
 * @param {HTML} renderedTemplate - the given modal HTML (must be contained in one wrapping element that has a unique id)
 * @return {Object} $modal - jQuery object of the newly generated modal.
 */
function generateModal(renderedTemplate) {
    var $body = $('body');
    $body.spinner().start();

    var parsedHTML = $.parseHTML($.trim(renderedTemplate));
    $body.append(parsedHTML);

    var $modal = $body.find(parsedHTML);

    // Remove any previous generated modals with this ID value (except this one)
    $('#' + $modal.attr('id') + ':not(:last-child)').remove();

    $modal.modal('show');
    $.spinner().stop();

    return $modal;
}

module.exports.create = generateModal;
